module.exports = __webpack_public_path__ + "static/militar-329e27a0164860f82e460f45b690b983.gif";